import {getContactListCount, getDashboardCount} from './normalizeContactList';

const filterByUserSearch = (list, userSearch) => {
	const filteredList = [];

	list.forEach(({contacts, ...rest}) => {
		const filteredContacts = contacts.filter(({name, lastName}) =>
			`${name} ${lastName}`.toLowerCase().includes(userSearch.toLowerCase())
		);
		if (filteredContacts.length !== 0)
			filteredList.push({
				...rest,
				contacts: filteredContacts,
				contactsCount: filteredContacts.length,
				dashboardCount: getDashboardCount(filteredContacts),
				contactListCount: getContactListCount(filteredContacts)
			});
	});

	return filteredList;
};

export const filterByCountry = (countryList, engagements) => {
	if (engagements.length === 0) return false;

	let meetTheCountry = [];

	countryList.forEach((countryId) => {
		let filtered = engagements.filter((engagement) => engagement.countryId === countryId);
		if (filtered.length > 0) {
			meetTheCountry.push(filtered);
		}
	});

	if (meetTheCountry.length === 0) return false;
	return true;
};

export const filterByGroupRole = (groupRoleList, engagements) => {
	if (engagements.length === 0) return false;

	let meetTheGroupRole = [];

	groupRoleList.forEach((groupRoleId) => {
		let filtered = engagements.filter((engagement) => engagement.groupRoleId === groupRoleId);
		if (filtered.length > 0) {
			meetTheGroupRole.push(filtered);
		}
	});

	if (meetTheGroupRole.length === 0) return false;
	return true;
};

export const filterByEngagement = (engagementList, engagements) => {
	if (engagements.length === 0) return false;

	let meetTheEngagementId = [];

	engagementList.forEach((engagementId) => {
		let filtered = engagements.filter((engagement) => engagement.engagementId === engagementId);
		if (filtered.length > 0) {
			meetTheEngagementId.push(filtered);
		}
	});

	if (meetTheEngagementId.length === 0) return false;
	return true;
};

export const filterByServiceLine = (serviceLineList, serviceLineId) => {
	let meetTheServiceLine = serviceLineList.filter((serviceLine) => serviceLine === serviceLineId);
	if (meetTheServiceLine.length === 0) return false;
	return true;
};

export const filterByRole = (roleList, roleId) => {
	let meetTheRole = roleList.filter((role) => role === roleId);
	if (meetTheRole.length === 0) return false;
	return true;
};

export const filterByEntities = (entityList, entities) => {
	if (entities.length === 0) return false;

	let meetTheEntitytId = [];

	entityList.forEach((entityId) => {
		const filtered = entities.filter((entity) => entity.id === entityId);
		if (filtered.length > 0) {
			meetTheEntitytId.push(filtered);
		}
	});

	if (meetTheEntitytId.length === 0) return false;
	return true;
};

export const filterByContactListAccess = (contactListAccess, contactList) => {
	if (contactList.hasAccess !== contactListAccess) return false;
	return true;
};

export const filterByGroupRiskAssesmentAccess = (graAccess, groupRiskAssessment) =>
	groupRiskAssessment.hasAccess === graAccess;

export const filterByTags = (tagList, tags) => {
	let meetTheTag = [];

	tagList.forEach((tagId) => {
		let filtered = tags.filter((tag) => tag.id === tagId);
		if (filtered.length > 0) {
			meetTheTag.push(filtered);
		}
	});

	if (meetTheTag.length === 0) return false;
	return true;
};

export const filterByDashboardAccess = (dashboardAccess, dashboard) => {
	if (dashboard?.length === 0 && dashboardAccess) return false;
	if (dashboard?.length !== 0 && !dashboardAccess) return false;
	return true;
};

export const filterByType = (type, isInternal) => {
	if (type.length === 2) return true;
	if (type[0] === 2 && isInternal) return false;
	if (type[0] === 1 && !isInternal) return false;
	return true;
};

const meetsFilters = (
	filterTypes,
	engagements,
	isInternal,
	serviceLineId,
	roleId,
	contactList,
	tags,
	dashboard,
	groupRiskAssessment
) => {
	const {
		contactsbycountry,
		contactsbygrouprole,
		contactsbyengagement,
		contactsbyserviceline,
		contactsbyrole,
		contactlist,
		contactsbytag,
		dashboardaccess,
		type,
		groupaccess
	} = filterTypes;

	if (contactsbycountry?.length > 0 && !filterByCountry(contactsbycountry, engagements)) return false;
	if (contactsbygrouprole?.length > 0 && !filterByGroupRole(contactsbygrouprole, engagements)) return false;
	if (contactsbyengagement?.length > 0 && !filterByEngagement(contactsbyengagement, engagements)) return false;
	if (contactsbyserviceline?.length > 0 && !filterByServiceLine(contactsbyserviceline, serviceLineId)) return false;
	if (contactsbyrole?.length > 0 && !filterByRole(contactsbyrole, roleId)) return false;
	if (typeof contactlist === 'boolean' && !filterByContactListAccess(contactlist, contactList)) return false;
	if (contactsbytag?.length > 0 && !filterByTags(contactsbytag, tags)) return false;
	if (typeof dashboardaccess === 'boolean' && !filterByDashboardAccess(dashboardaccess, dashboard)) return false;
	if (typeof groupaccess === 'boolean' && !filterByGroupRiskAssesmentAccess(groupaccess, groupRiskAssessment))
		return false;
	if (type?.length > 0 && !filterByType(type, isInternal)) return false;
	return true;
};

const filterByOptions = (list, filterTypes) => {
	const filteredList = [];

	list.forEach(({contacts, ...rest}) => {
		const filteredContacts = contacts.filter(
			({engagements, isInternal, serviceLineId, roleId, contactList, tags, dashboard, groupRiskAssessment}) => {
				return meetsFilters(
					filterTypes,
					engagements,
					isInternal,
					serviceLineId,
					roleId,
					contactList,
					tags,
					dashboard,
					groupRiskAssessment
				);
			}
		);

		if (filteredContacts.length !== 0)
			filteredList.push({
				...rest,
				contacts: filteredContacts,
				contactsCount: filteredContacts.length,
				dashboardCount: getDashboardCount(filteredContacts),
				contactListCount: getContactListCount(filteredContacts)
			});
	});

	return filteredList;
};

const hasFilters = (filterTypes) => {
	if (
		filterTypes.contactsbycountry?.length > 0 ||
		filterTypes.contactsbygrouprole?.length > 0 ||
		filterTypes.contactsbyengagement?.length > 0 ||
		filterTypes.contactsbyserviceline?.length > 0 ||
		filterTypes.contactsbyrole?.length > 0 ||
		typeof filterTypes.contactlist === 'boolean' ||
		filterTypes.contactsbytag?.length > 0 ||
		typeof filterTypes.dashboardaccess === 'boolean' ||
		typeof filterTypes.groupaccess === 'boolean' ||
		filterTypes.type?.length > 0
	) {
		return true;
	}

	return false;
};

export default (normalizedFilters, normalizedEntities) => {
	const {userSearch = null, filterTypes = null, ...otherFilters} = normalizedFilters;

	let filteredEntities = [...normalizedEntities];

	if (userSearch) filteredEntities = filterByUserSearch(filteredEntities, userSearch);

	if (filterTypes && hasFilters(filterTypes)) filteredEntities = filterByOptions(filteredEntities, filterTypes);

	return filteredEntities;
};
